/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityServiceAreaStatus } from './FacilityServiceAreaStatus';
import {
    FacilityServiceAreaStatusFromJSON,
    FacilityServiceAreaStatusFromJSONTyped,
    FacilityServiceAreaStatusToJSON,
} from './FacilityServiceAreaStatus';

/**
 * 
 * @export
 * @interface CreateFacilityServiceAreaRequest
 */
export interface CreateFacilityServiceAreaRequest {
    /**
     * A 5-digit US ZIP code (e.g. "10001").
     * @type {string}
     * @memberof CreateFacilityServiceAreaRequest
     */
    zip: string;
    /**
     * 
     * @type {FacilityServiceAreaStatus}
     * @memberof CreateFacilityServiceAreaRequest
     */
    status: FacilityServiceAreaStatus;
    /**
     * 
     * @type {string}
     * @memberof CreateFacilityServiceAreaRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFacilityServiceAreaRequest
     */
    state_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFacilityServiceAreaRequest
     */
    notes?: string;
}

/**
 * Check if a given object implements the CreateFacilityServiceAreaRequest interface.
 */
export function instanceOfCreateFacilityServiceAreaRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "zip" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function CreateFacilityServiceAreaRequestFromJSON(json: any): CreateFacilityServiceAreaRequest {
    return CreateFacilityServiceAreaRequestFromJSONTyped(json, false);
}

export function CreateFacilityServiceAreaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityServiceAreaRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'zip': json['zip'],
        'status': FacilityServiceAreaStatusFromJSON(json['status']),
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state_id': !exists(json, 'state_id') ? undefined : json['state_id'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function CreateFacilityServiceAreaRequestToJSON(value?: CreateFacilityServiceAreaRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'zip': value.zip,
        'status': FacilityServiceAreaStatusToJSON(value.status),
        'city': value.city,
        'state_id': value.state_id,
        'notes': value.notes,
    };
}

